import * as actionTypes from './actionTypes';

export const caseMenuInfo = caseMenuInfo => ({
  type: actionTypes.CASE_MENU,
  caseMenuInfo
})

export const resetCaseMenuInfo = () => ({
  type: actionTypes.RESET_CASE_MENU
})


// WEBPACK FOOTER //
// ./src/components/common/CaseMenu/actions/actionCreator.js